define.alias("ember-useragent/services/user-agent", "calendar/services/user-agent");